
export function sliders() {
    $('.models_slider').on('init', function (event,slick) {
      setTimeout(function(){
          if(slick.slideCount > 2 || $(window).width() <= 550) {
            //display dots if more than 2 cards or on mobile
              $('.models_slider .slick-dots').attr('role','presentation');
              $('.models_slider .slick-dots').show();
          }
          else{
              $('.models_slider .slick-dots').hide();
          }
      },100);
    });
    $('.models_slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 550,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
            }
        }],
    });

    $('.offersSlider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 650,
            settings: {
                slidesToShow: 1.2,
                slidesToScroll: 1,
                infinite:false,
                arrows: false,
            }
        }, {
            breakpoint: 1023,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
            }
        }],
    });

    $('.categories-slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        }
      }, {
        breakpoint: 800,
        settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
        }
      }],
    });

    $('.events-slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        }
      }, {
        breakpoint: 750,
        settings: $(".events-slider").hasClass("slick-on-mobile") ? {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
      }:"unslick"
      }],
    });

    $('.properties-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1150,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
      }
    },{
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
      }
    },{
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
      }
    } ,{
        breakpoint: 475,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
        } 
      }],
    });

    $('.model-page .colors_comp .colors_comp_slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        fade: true,
        asNavFor: '.colors_comp_slider_nav'
      });
      $('.model-page .colors_comp .colors_comp_slider_nav').on("init", function(slick) {
        $(".model-page .colors_comp .colors_comp_slider_nav .slick-track .slide-item").on('keydown', function (e) {
          if(e.which == 13 || e.which == 32){
            e.preventDefault();
            $(this).click();
          }
        });
        if($('.model-page .colors_comp .colors_comp_slider_nav .slick-track .slick-current .colors_comp_slider_item_color').length>0){
          $(this).show();
        }
      });
        
      var slidesToShow = $('.model-page .colors_comp .colors_comp_slider_nav').attr('data-length');
      $('.model-page .colors_comp .colors_comp_slider_nav').slick({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        asNavFor: '.colors_comp_slider',
        dots: false,
        arrows: false,
        //centerMode: true,
        focusOnSelect: true,
        infinite: false,
      });
      $('.model-page .colors_comp .colors_comp_slider_nav').on('afterChange', function(event, slick, currentSlide){
        setTimeout(function(){
          $(".model-page .colors_comp .colors_comp_slider_nav .slick-track .slide-item").attr('tabindex','0').attr('aria-pressed','false');
          $(".model-page .colors_comp .colors_comp_slider_nav .slick-track .slick-current").attr('aria-pressed','true');
          $('.model-page .colors_comp-popup-slider').slick('unslick').html('');
          $('.model-page .colors_comp .colors_comp_slider .slick-current img').each(function(){
            $('.model-page .colors_comp-popup-slider').append('<div class="colors_comp-popup-slider-item">'+$(this).parent().html()+'</div>');
          })
          $('.model-page .colors_comp .colors_comp_slider .slick-current iframe').each(function(){
            $('.model-page .colors_comp-popup-slider').append('<div class="colors_comp-popup-slider-item">'+$(this).parent().html()+'</div>');
          })
    
          $('.model-page .colors_comp-popup-slider').on("init", function(slick) {
            setTimeout(function(){
              
            },10);
          });
          var $slider = $('.model-page .colors_comp-popup-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev" aria-label="la précédente"></button>',
            nextArrow: '<button type="button" class="slick-next" aria-label="le suivant"></button>',
            //focusOnSelect: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  arrows: false,
                }
              },
            ]
          });
          $slider.find(".slick-slide").on("click", function(){
            $slider.slick('slickNext');
          });
        },10);
      });
    
      $('.model-page .colors_comp-popup-slider').on("init", function(slick) {
        setTimeout(function(){
    
        },10);
      });
      var $slider = $('.model-page .colors_comp-popup-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="la précédente"></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="le suivant"></button>',
        //focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: false,
            }
          },
        ]
      });
      $slider.find(".slick-slide").on("click", function(){
        $slider.slick('slickNext');
      });
      $('.model-page .colors_comp-popup-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.model-page .colors_comp-popup .slides-count span').html(nextSlide+1);
        $(".model-page .colors_comp-popup .modal-body .colors_comp-popup-slider-item.slick-current iframe").attr("src", $(".model-page .colors_comp-popup .modal-body .colors_comp-popup-slider-item.slick-current iframe").attr("src"));
      });
      
      $('.model-page .colors_comp .colors_comp_slider .slide-item .slide-wrap .slide-content a').click(function(){
        $('.model-page .colors_comp-popup-slider').slick('slickGoTo', $(this).attr('data-id'));
        $('header.header').css('z-index','0');
        $('footer .logo-line .site-logo-footer').css('z-index','-1');
        $("div[id*='ZA_CAMP_BUBBLE_CONTAINER_CID_']").css('z-index','-1');
        $('.model-page .colors_comp-popup.modal-mask').show();
        $('.model-page .colors_comp-popup .modal-header .o-modal__close').focus();
      })
      $('.model-page .colors_comp .colors_comp_slider .slide-item .slide-wrap .slide-content a').on('keydown', function (e) {
        if (e.which === 13 || e.which === 32) {
          e.preventDefault();
          $(this).click();
        }
      });
      $('.model-page .colors_comp-popup .modal-header .o-modal__close').click(function(){
        $('header.header').css('z-index','100');
        $('footer .logo-line .site-logo-footer').css('z-index','0');
        $("div[id*='ZA_CAMP_BUBBLE_CONTAINER_CID_']").css('z-index','2147483643');
        $('.model-page .colors_comp-popup.modal-mask').hide();
        let data_id = $(".model-page .colors_comp-popup .modal-body .colors_comp-popup-slider-item.slick-current").attr('data-slick-index');
        $('.model-page .colors_comp .colors_comp_slider .slide-item.slick-current .slide-wrap .slide-content a[data-id="'+data_id+'"]').focus();
        $(".model-page .colors_comp-popup .modal-body .colors_comp-popup-slider-item.slick-current iframe").attr("src", $(".model-page .colors_comp-popup .modal-body .colors_comp-popup-slider-item.slick-current iframe").attr("src"));
      });
      $('.model-page .colors_comp-popup .modal-header .o-modal__close').on('keydown', function (e) {
        if ((e.which === 9 && e.shiftKey)) {
          e.preventDefault();
        }
      });
      $('.model-page .colors_comp-popup .endOfModal').on('keydown', function (e) {
        if ((e.which === 9 && !e.shiftKey)) {
          e.preventDefault();
        }
      });
      
      $(document).on('keydown', function (e) {
        if (e.which === 27) {
          e.preventDefault();
          $('.model-page .colors_comp-popup .modal-header .o-modal__close').click();
        }
      });
}
